export class AdHocInstructionRetailD2Forecast {
    public forecastDate: string;
    public argus: number;
    public leba_8_9: number;
    public leba_all: number;
    public n2EX: number;
    public pX: number;
}